// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------
// /assets/icons/navbar/${name}.svg
const icon = (name) => (
  <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const OBProduction = [
  {
    title: 'Operation Bulletin',
    path: '/dashboard/manage/operation_bulletin',
    icon: icon('obt'),
    ShortName: 'Transaction_OperationBulletin',
  },
  {
    title: 'Time & Study',
    path: '/dashboard/manage/time_and_study',
    icon: icon('ts'),
    ShortName: 'Transaction_Time_and_Study',
  },
  {
    title: 'Daily Production',
    path: '/dashboard/manage/daily_production',
    icon: icon('daily'),
    ShortName: 'Transaction_DailyProduction',
  },
  {
    title: 'Other Process',
    path: '/dashboard/manage/other_production',
    icon: icon('otherProcessTransaction'),
    ShortName: 'Transaction_OtherProduction',
  },
  // {
  //   title: 'Hourly Production',
  //   path: '/dashboard/reports/daily_production_hourly',
  //   icon: icon('hourly'),
  //   ShortName: 'Reports_HourlyProduction',
  // },
  // {
  //   title: 'OB Status',
  //   path: '/dashboard/reports/OBStatus',
  //   icon: icon('obstatus1'),
  //   ShortName: 'Reports_ObStatus',
  // },
  // {
  //   title: 'Production Tracker Report',
  //   path: '/dashboard/reports/ReportTracker',
  //   icon: icon('reportTracker'),
  //   ShortName: 'Reports_ReportTracker',
  // },
  // {
  //   title: 'Day Wise Production Cost',
  //   path: '/dashboard/reports/DayWiseProductionCostReport',
  //   icon: icon('reportTracker'),
  //   ShortName: 'Reports_DayWiseProductionCostReport',
  // },
  // {
  //   title: 'Monthly Production',
  //   path: '/dashboard/reports/monthly_wise_production',
  //   icon: icon('month'),
  //   ShortName: 'Reports_MonthlyProduction',
  // },
  // {
  //   title: 'Skill Matrix(Daily)',
  //   path: '/dashboard/reports/daily_skillmatrix',
  //   icon: icon('idea'),
  //   ShortName: 'Reports_SkillMatrixDaily',
  // },
];

export default OBProduction;
